import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-column-selector',
  templateUrl: './column-selector.component.html'
})
export class ColumnSelectorComponent implements OnInit{
 @Input() allColumns: { name: string; label: string }[] = [];
  @Input() defaultColumns: string[] = [];
  @Input() storageKey: string = '';

  // Two-way binding support
  @Input() value: string[] = [];
  @Output() valueChange = new EventEmitter<string[]>();

 ngOnInit() {
   const saved = this.storageKey ? localStorage.getItem(this.storageKey) : null;
    this.value = saved ? JSON.parse(saved) : [...this.defaultColumns];
    this.saveToStorageAndEmit();
 }

  private saveToStorageAndEmit() {
    if (this.storageKey) {
      localStorage.setItem(this.storageKey, JSON.stringify(this.value));
    }
    this.valueChange.emit(this.value);
  }

  onSelectionChange() {
    this.saveToStorageAndEmit();
  }
  
}
